import React, { useCallback } from "react";
import './trip-create.style.scss';
import { BusSelectionForm } from './bus-selection-form/bus-selection-form';
import { TripCreateMapRoot } from './trip-create-map-root';
import { TripCreateTimeRoot } from './trip-create-time-root';
import { useDispatch } from 'react-redux';
import { loadingAction } from "../../actions/loading-actions";

export const TripCreateRoute = (props) => {
    const {
        onCallBackSetDirections,
        masterCities,
        busesData,
        isTripCityCreated,
        addStop,
        tripScheduleId,
        setShowVerifyPage,
        setHeaderStep,
        stepDataVal,
        setStepDataVal,
        selectedSeatNumbers,
        setSelectedSeatNumbers,
        setShowSelectCity,
        showSelectCity,
        setDistance,
        setDuration,
        addStopComponent,
        customClassName,
        childRef,
        setCitiesChanged,
        setSelectedMethod,
        selectedMethod,
        busFormData: parentBusFormData,
        setBusFormData: setParentBusFormData,
        setAddStop,
        setSelectedPartner,
        temporaryFlowState
    }= props;

    const dispatch = useDispatch();

    const handleMethodSelect = useCallback((method, formData) => {
        // Start loading when continue button is clicked
        dispatch(loadingAction(true));
        
        setSelectedMethod(method);
        setParentBusFormData(formData);
        // Move to next step (Select Cities)
        setHeaderStep(1);
        // Update stepDataVal to trigger the correct component rendering
        setStepDataVal({ 'headerFormPos': 1 });
        // Stop loading after data is processed
        dispatch(loadingAction(false));
    }, [setSelectedMethod, setHeaderStep, dispatch, setParentBusFormData, setStepDataVal]);

    const commonProps = {
        onCallBackSetDirections,
        masterCities,
        busesData,
        isTripCityCreated,
        addStop,
        tripScheduleId,
        setShowVerifyPage,
        setHeaderStep,
        stepDataVal,
        selectedSeatNumbers,
        setSelectedSeatNumbers,
        setShowSelectCity,
        showSelectCity,
        setDistance,
        setDuration,
        addStopComponent,
        customClassName,
        childRef,
        setCitiesChanged,
        busFormData: parentBusFormData,
        selectedMethod,
        setAddStop,
        temporaryFlowState
    };

    // Determine which component to render based on step and method
    const currentStep = stepDataVal?.headerFormPos || 0;
    const shouldShowBusSelection = currentStep === 0;

    return (
        <>
            {shouldShowBusSelection ? (
                <div className={`side-nav ${customClassName}`} >
                    <div style= {{alignItems: 'center'}}>
                        <BusSelectionForm
                            busesData={busesData}
                            selectedSeatNumbers={selectedSeatNumbers}
                            setSelectedSeatNumbers={setSelectedSeatNumbers}
                            onMethodSelect={handleMethodSelect}
                            busFormData={parentBusFormData}
                            selectedMethod={selectedMethod}
                            tripScheduleId = {tripScheduleId}
                            setSelectedPartner={setSelectedPartner}
                        />
                    </div>
                </div>
            ) : selectedMethod === 'map' ? (
                <TripCreateMapRoot {...commonProps} />
            ) : (
                <div className={`time-method-container ${customClassName}`} >
                    <div style= {{alignItems: 'center'}}>
                        <TripCreateTimeRoot {...commonProps} />
                    </div>
                </div>
            )}
        </>
    )
}